import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
//import { MsalService } from '@azure/msal-angular';
import { ClientssoService } from '../services/clientsso.service';
import { Observable, take, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DualSsoGuard implements CanActivate {
  constructor(
    // private msalService: MsalService,
    private clientSsoService: ClientssoService,
    private router: Router,
  ) {}

  private sleep(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.clientSsoService.isAuthenticated$.pipe(
      take(1),
      map((isAuthenticated) => {
        if (isAuthenticated) {
          return true;
        }
        console.warn('User not authenticated. Redirecting to SSO login.');
        // debugger;
        this.clientSsoService.loginWithOkta();
        // Store the attempted URL for redirecting after login
        // this.router.navigate(['/login'], {
        //   queryParams: { returnUrl: state.url },
        // });
        return false;
      }),
    );
  }
}
